// extracted by mini-css-extract-plugin
export default {"dropdown":"Dropdown_dropdown__QIkg0","item":"Dropdown_item__tqQTW"};